import { styled } from '@mui/material/styles';
import NextImage from 'next/image';

export const Image = styled(NextImage)(() => ({
  maxWidth: '100%',
  height: 'auto',
}));
